import md5 from 'md5'

/** Build a Gravatar avatar URL for an email (Mystery Person fallback). */
export function gravatarUrl(email, size = 32) {
  const hash = md5(String(email).trim().toLowerCase())
  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=mp`
}
